export const REGISTRATION_ENDPOINT = {
  BASE: 'registration-service',
  REGISTRATION: 'demo-client',
  REGISTRATION_CWO_CUSTOMER: 'cwo-customer',
  REGISTRATION_TITANGUESTREG: 'titan-guest',
  REGISTRATION_TITANGUESTREG_CLOUD: 'titan-guest-cloud',
  TOKEN_VALIDATE: 'token-validate',
};
